import {
    ASYNC_FETCH,
    ASYNC_FETCH_SUCCESS_ILDEFFECTIVEDATE,
    ASYNC_FETCH_ILDFAILURE,
    ASYNC_FETCH_ILDINVALIDATE,
    SET_SELECTED_ILDEFFECTIVE_DATE
  } from '../constants';
  import { updateObject } from '../../../shared/utilities/reducer';
  import common from '../../../shared/utilities/common';
  
  const initialState = {
    isFetching: true,
    statusCode: "",
    statusMessage: "",
    errorMessage: '',
    errorDesc: '',
    actionName: '',
    actionValue: '',
    errorObj: {},
    pageData: {},
    selectedEffectiveDate: {}
  }
  
  
  
  export const asyncFetch = (state, action) => {
    console.log("getSectionsBegin called")
    return updateObject(state, {
      isFetching: true
    });
  };
  
  export const asyncFetchSuccess = (state, action) => {
    return updateObject(state, {
      isFetching: false,
      statusCode: action.msResp.responseInfo.responseCode,
      statusMessage: action.msResp.responseInfo.responseMessage,
      errorMessage: common.isError(action.msResp.responseInfo.responseCode, action.msResp.responseInfo.responseMessage, action.msResp.body),
      errorDesc: common.isErrorDesc(action.msResp.responseInfo.responseCode, action.msResp.responseInfo.responseMessage, action.msResp.body),
      actionName: common.isActionName(action.msResp.responseInfo.responseCode, action.msResp.responseInfo.responseMessage, action.msResp.body),
      actionValue: common.isActionValue(action.msResp.responseInfo.responseCode, action.msResp.responseInfo.responseMessage, action.msResp.body),
      errorObj: action.msResp.responseInfo.responseCode !== "00" && action.msResp.responseInfo ? action.msResp.responseInfo.sectionErrors : null,
      pageData: action.msResp.body 
    });
  };
  
  export const asyncFetchFailed = (state, action) => {
  
    //Dont Delete this code untill implementing code to handel 500 status code error
    let msResp = action && action.err && action.err.response && action.err.response.data;
    let responseCode = msResp && msResp.responseInfo && msResp.responseInfo.responseCode;
    let responseMessage = msResp && msResp.responseInfo && msResp.responseInfo.responseMessage;
    let body = msResp && msResp.body;
    return updateObject(state, {
      isFetching: false,
      pageData: {},
      statusCode: responseCode ? responseCode : '',
      errorMessage: common.isError(responseCode, responseMessage, body),
      errorDesc: common.isErrorDesc(responseCode, responseMessage, body),
      actionName: common.isActionName(responseCode, responseMessage, body),
      actionValue: common.isActionValue(responseCode, responseMessage, body),
      errorObj: responseCode !== "00" && msResp && msResp.responseInfo ? msResp.responseInfo.sectionErrors : action.err,
    });
  };
  
  
  export const setSelectedEffectiveDateValue = (state, action) => {
    return updateObject(state, {
      selectedEffectiveDate: action.data
    });
  };
  
  export const ILDEffectiveDateReducer = (state = initialState, action) => {
  
    const { type } = action;
    switch (type) {
      case ASYNC_FETCH:
        return asyncFetch(state, action);
      case ASYNC_FETCH_SUCCESS_ILDEFFECTIVEDATE:
        return asyncFetchSuccess(state, action);
      case ASYNC_FETCH_ILDFAILURE:
        return asyncFetchFailed(state, action);
      // case ASYNC_FETCH_ILDINVALIDATE:
      //   return Object.assign({}, state, { isFetching: false, pageData: {} });
      case SET_SELECTED_ILDEFFECTIVE_DATE:
        return setSelectedEffectiveDateValue(state, action);
      default:
        return state;
    }
  };
  